<script>
import { mapState } from 'vuex'
import StatusItems from '@/components/general/StatusItems.vue' // Assuming the component file is named StatusItems.vue
import ProgressGraph from '@/components/general/progress-graph.vue'

export default {
  components: {
    StatusItems,
    ProgressGraph,
  },

  data: function () {
    return {
      statuses: ['Ideation', 'Wireframes', 'In Dev', 'MVP', 'Tweaks', 'Launch'],
      tab: 0,
    }
  },

  computed: {
    ...mapState('releases', ['roadmap']),
    groupedRoadmap() {
      // Groups the roadmap by project
      return this.roadmap?.length
        ? this.roadmap.reduce((acc, item) => {
            const roadmapGroup = item.roadMapGroup
            const existingGroup = acc.find(
              (group) => group.title === roadmapGroup
            )

            if (existingGroup) {
              existingGroup.items.push(item)
            } else {
              acc.push({ title: roadmapGroup, items: [item] })
            }

            return acc
          }, [])
        : [{ title: 'No Roadmap Available', items: [] }]
    },
    tabs() {
      return this.groupedRoadmap.map(({ title }) => title)
    },
    groupItems() {
      const currentTab = this.tabs[this.tab]
      return this.groupedRoadmap.find((item) => item.title === currentTab)
        ?.items
    },
  },
  methods: {},
}
</script>

<template>
  <v-container>
    <h1>Roadmap</h1>
    <v-tabs v-model="tab" background-color="transparent">
      <v-tab v-for="(group, index) in tabs" :key="index">
        {{ group }}
      </v-tab>
    </v-tabs>
    <v-tabs-items id="releases-tab-items" v-model="tab">
      <v-tab-item v-for="(group, index) in tabs" :key="index">
        <div v-if="groupItems.length" class="roadmap-group-items my-8 px-2">
          <div v-for="wi in groupItems" :key="wi.id" class="sub-change">
            <ProgressGraph
              :percentage-complete="parseInt(wi.roadMapPercentComplete)"
            />
            <div class="status-title">{{ wi.roadMapTitle }}</div>
            <div
              class="status-description"
              v-html="wi.roadMapDescription"
            ></div>
            <StatusItems
              :labels="statuses"
              :highlighted-item="wi.roadMapStatus"
            />
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<style lang="scss" scoped>
.roadmap-group-items {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  grid-auto-flow: row;
  width: 100%;
  gap: 20px;
}
.sub-change {
  position: relative;
  flex-shrink: 0;
  width: 100%;
  padding: 5px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  .graph {
    position: absolute;
    right: 10px;
    width: 100px;
  }
  .status-title {
    padding: 5px 10px;
    padding-right: 105px;
  }
  .status-description {
    padding: 5px 10px;
  }
}
</style>
